export const permissions = {
  // supply-chain-management
  VIEW__ADMIN_ROLE: 'permissionManagement_read',
  EDIT__ADMIN_ROLE: 'permissionManagement_write',
  VIEW__ADMIN_USER: 'userManagement_read',
  EDIT__ADMIN_USER: 'userManagement_write',
  VIEW__ADMIN_SUPPLIER: 'vendorManagement_read',
  EDIT__ADMIN_SUPPLIER: 'vendorManagement_write',
  VIEW__ADMIN_SKU: 'skuManagement_read',
  EDIT__ADMIN_SKU: 'skuManagement_write',
  VIEW__ADMIN_SUB_SERVICE: 'subserviceManagement_read',
  EDIT__ADMIN_SUB_SERVICE: 'subserviceManagement_write',
  VIEW__ADMIN_ANNOUNCEMENT: 'announcementManagement_read',
  EDIT__ADMIN_ANNOUNCEMENT: 'announcementManagement_write',
  VIEW__ADMIN_ORDER: 'orderManagement_read',
  EDIT__ADMIN_ORDER: 'orderManagement_write',
  VIEW__ADMIN_ORDER_DOWNLOAD: 'orderDownload_read',
  VIEW__ADMIN_RETURN: 'returnManagement_read',
  EDIT__ADMIN_RETURN: 'returnManagement_write',
  VIEW__ADMIN_RETURN_DOWNLOAD: 'returnDownload_read',
  VIEW__ADMIN_DASHBOARD: 'dashboardManagement_read',
  EDIT__ADMIN_DASHBOARD: 'dashboardManagement_write',
  VIEW__ADMIN_SUPPORT_CASE: 'supportCaseManagement_read',
  EDIT__ADMIN_SUPPORT_CASE: 'supportCaseManagement_write',
  VIEW__ADMIN_B2C_TOOLBOX: 'b2cToolbox_read',
  EDIT__ADMIN_B2C_TOOLBOX: 'b2cToolbox_write',
  VIEW__ADMIN_SHOP: 'shopManagement_read',
  EDIT__ADMIN_SHOP: 'shopManagement_write',
  // suppliers-management
  VIEW__SUPPLIER_ROLE: 'permissionManagement_read',
  EDIT__SUPPLIER_ROLE: 'permissionManagement_write',
  VIEW__SUPPLIER_USER: 'userManagement_read',
  EDIT__SUPPLIER_USER: 'userManagement_write',
  VIEW__SUPPLIER_SKU: 'skuManagement_read',
  EDIT__SUPPLIER_SKU: 'skuManagement_write',
  VIEW__SUPPLIER_OUTBOUND: 'orderManagement_read',
  EDIT__SUPPLIER_OUTBOUND: 'orderManagement_write',
  VIEW__SUPPLIER_OUTBOUND_DOWNLOAD: 'orderDownload_read',
  VIEW__SUPPLIER_RETURN: 'returnManagement_read',
  EDIT__SUPPLIER_RETURN: 'returnManagement_write',
  VIEW__SUPPLIER_RETURN_DOWNLOAD: 'returnDownload_read',
  // @todo change to dashboardManagement
  VIEW__SUPPLIER_DASHBOARD: 'dashboardManagement_read',
  EDIT__SUPPLIER_DASHBOARD: 'dashboardManagement_write',
  VIEW__SUPPLIER_SUPPORT_CASE: 'supportCaseManagement_read',
  EDIT__SUPPLIER_SUPPORT_CASE: 'supportCaseManagement_write',
};

export const permissionChActions = {
  read: '檢視',
  write: '編輯',
};
